import EmissionsData from "./data";

export default function emissionsDataFromJson(json) {
  return new EmissionsData(
    json.fuelLowSulfur,
    json.fuelOil
  );
}
